import React from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../store/slices/formconfig';


interface Props {
  show: boolean;
  onClose: () => void;
  onSubmit: (internalRemarks: string) => void;
}

const CancelModal: React.FC<Props> = ({ show, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const [internalRemarks, setInternalRemarks] = React.useState('');

  if (!show) {
    return null;
  }

  const handleReject = () => {
    // The alert is still a good fallback for user feedback
    if (internalRemarks) {
      onSubmit(internalRemarks);
  
      setInternalRemarks('');
    } else {
      dispatch(showToast({ message: 'Please fill out all required fields.', type: 'error' }));
    }
  };
  
  // New validation check
  const isFormValid =  internalRemarks !== '';

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{padding: 20}}>
        <div className="modal-header">
          <span className='headerreject'>Cancel Certificate</span>
          <span className="close-button" onClick={onClose}>&times;</span>
        </div>
        <div className="modal-body" style={{marginBottom:0}}>
         
          <div className="form-group">
            <label className='subhead'>Internal remarks  <mark style={{background:'transparent', color:'red'}}>*</mark></label>
            <textarea
              value={internalRemarks}
              onChange={(e) => setInternalRemarks(e.target.value)}
              placeholder="Add detailed notes for the internal team here..."
            />
          </div>
        </div>
        <div className="modal-footer" style={{padding:0}}>
          <button
            className={isFormValid?"reject-request-button": "reject-request-button disabled"}
            onClick={handleReject}
            disabled={!isFormValid}
          >
            Cancel Request
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelModal;